/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//

const MOVE_STEP = 128;
const SWITCH_PADDING = 8;

/**
 * Switcher menu, used to display a nice menu to switch between selected items.
 * The item to switch from are just a pair of object with label/value properties.
 * Label for the display, and value to emit when clicked upon
 *
 * @vue-prop {Object[]} choices
 * @vue-prop {String} value
 *
 * @category ui.components.navigation
 * @exports DropdownMenu
 * @component
 */
const __vue_script__ = {
    name: 'SwitcherMenu',

    props: {
        choices: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            fallbackFloaterStyle: {},
            leftMove: 0,
            wrapperWidth: 0
        };
    },

    computed: {
        isDisabledLeft() {
            return this.leftMove === 0;
        },

        isDisabledRight() {
            return this.leftMove === this.maxLeft;
        },

        /**
        * To better understand :
        * The left part of the Math.max
        *  <--------------maxLeft-----------><---wrapperWidth---> : the position wrapper and its left position
        *  <--this.choices.length * MOVE_STEP + SWITCH_PADDING--> : the actual things to switch between (all the choices + its padding)
        * The 0 part of Math.max:
        * <------------------------wrapperWidth----------------------------->
        * <--this.choices.length * MOVE_STEP + SWITCH_PADDING-->
        */
        maxLeft() {
            return Math.max(this.choices.length * MOVE_STEP + SWITCH_PADDING - this.wrapperWidth, 0);
        },

        positionChange() {
            return {
                left: `-${this.leftMove}px`
            };
        }
    },

    mounted() {
        this.updateWrapperWidth();
    },

    methods: {
        clickLeft() {
            if (!this.isDisabledLeft) {
                this.leftMove = Math.max(0, this.leftMove - MOVE_STEP);
            }
        },

        clickRight() {
            if (!this.isDisabledRight) {
                this.leftMove = Math.min(this.maxLeft, this.leftMove + MOVE_STEP);
            }
        },

        switchTab(choice) {
            // Fallback if anchor positioning is not supported.
            if (!('anchorName' in document.documentElement.style)) {
                this.fallbackFloaterStyle = {
                    left: `${this.choices.indexOf(choice) * MOVE_STEP + SWITCH_PADDING / 2}px`
                };
            }
            this.$emit('switch', choice.value);
        },

        updateWrapperWidth() {
            this.wrapperWidth = this.$refs.position_wrapper.getBoundingClientRect().width;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switcher-menu"},[_c('a',{class:{ disabled: _vm.isDisabledLeft },on:{"click":function($event){$event.preventDefault();return _vm.clickLeft.apply(null, arguments)}}},[_c('i',{staticClass:"ic-chevron-left"})]),_c('div',{ref:"position_wrapper",staticClass:"position-wrapper"},[_c('div',{staticClass:"switching-part",style:(_vm.positionChange)},[_c('div',{staticClass:"floater",style:(_vm.fallbackFloaterStyle)}),_vm._l((_vm.choices),function(choice){return _c('div',{staticClass:"tab",class:{ 'active-anchor': choice.value === _vm.value },on:{"click":function($event){return _vm.switchTab(choice)}}},[_vm._v(_vm._s(choice.label))])})],2)]),_c('a',{class:{ disabled: _vm.isDisabledRight },on:{"click":function($event){$event.preventDefault();return _vm.clickRight.apply(null, arguments)}}},[_c('i',{staticClass:"ic-chevron-right"})]),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SwitcherMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__